import { useState } from 'react';

const getSelectedProperties = (propertyDataRows, excludedPropertiesMap) => {
  return propertyDataRows.reduce((selectedPropertyDataRows, property) => {
    const isExcluded = excludedPropertiesMap[property.propertyId];

    if (!isExcluded) {
      selectedPropertyDataRows.push(property.propertyId);
    }

    return selectedPropertyDataRows;
  }, []);
};

export const usePreferredProperties = ({
  excludedPropertiesMap,
  setExcludedPropertiesMap,
  propertyDataRows,
  updateCrossSell,
}) => {
  const [selectedProperties, setSelectedProperties] = useState(
    getSelectedProperties(propertyDataRows, excludedPropertiesMap),
  );

  const updateSelectedProperties = (selectedPropertyIds) => {
    const selectedPropertyIdsSetMap = selectedPropertyIds.reduce(
      (map, propertyId) => {
        map[propertyId] = true;
        return map;
      },
      {},
    );

    const updatedExcludedProperties = propertyDataRows.reduce(
      (excludedProperties, property) => {
        const isExcluded = !selectedPropertyIdsSetMap[property.propertyId];
        if (isExcluded) {
          excludedProperties.excludedPropertiesList.push(property.propertyId);
        }
        excludedProperties.excludedPropertiesMap[property.propertyId] =
          isExcluded;

        return excludedProperties;
      },
      {
        excludedPropertiesList: [],
        excludedPropertiesMap: { ...excludedPropertiesMap },
      },
    );

    const updatedExcludedPropertiesMap = {
      ...excludedPropertiesMap,
      ...updatedExcludedProperties.excludedPropertiesMap,
    };

    setSelectedProperties(selectedPropertyIds);
    setExcludedPropertiesMap(updatedExcludedPropertiesMap);
    updateCrossSell(updatedExcludedProperties.excludedPropertiesList);
  };

  return {
    selectedProperties,
    updateSelectedProperties,
  };
};
